/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AddressDTO,
  AddressWithLegalFormDTO,
  ErrorResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AddressApi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Update the address of a company
   *
   * @tags address-api
   * @name UpdateAddress1
   * @summary Update address
   * @request POST:/api/address/{id}
   * @secure
   */
  updateAddress1 = (id: number, data: AddressDTO, params: RequestParams = {}) =>
    this.request<AddressDTO, ErrorResponse | AddressDTO>({
      path: `/api/address/${id}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Atomically updates the company address's country together with a new, compatible legal form on the company
   *
   * @tags address-api
   * @name UpdateAddressWithLegalForm
   * @summary Update company address with legal form
   * @request POST:/api/address/{id}/with-legal-form
   * @secure
   */
  updateAddressWithLegalForm = (
    id: number,
    data: AddressWithLegalFormDTO,
    params: RequestParams = {},
  ) =>
    this.request<AddressDTO, ErrorResponse | AddressDTO>({
      path: `/api/address/${id}/with-legal-form`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
